import type { CanvasContentBase, CanvasEntityDefinition } from '@factorialco/f0-react'

/**
 * Identity helper that preserves the content-type parameter so each entity
 * file gets full inference on `content`, `onClose`, and `refreshKey` without
 * needing a `Record<string, CanvasEntityDefinition<any>>` cast at the call site.
 */
export const defineCanvasEntity = <T extends CanvasContentBase>(
  def: CanvasEntityDefinition<T>
): CanvasEntityDefinition<T> => def
